import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { ApiError, apiFetch, v1Path } from '../lib/api';
import type { WorkItemFull } from '../lib/work-types';

export default function BrowseRedirect() {
  const { workItemKey } = useParams<{ workItemKey: string }>();
  const [target, setTarget] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!workItemKey) {
      setError('Missing work item key.');
      return;
    }
    void apiFetch<WorkItemFull>(v1Path(`/work-items/${encodeURIComponent(workItemKey)}`))
      .then((item) => {
        setTarget(`/projects/${item.project_id}/work-items/${item.id}`);
      })
      .catch((err) => {
        if (err instanceof ApiError) setError(err.message);
        else setError(err instanceof Error ? err.message : 'Not found');
      });
  }, [workItemKey]);

  if (target) return <Navigate to={target} replace />;
  return (
    <div className="p-8 text-center text-sm text-muted-foreground">
      {error ?? 'Opening work item…'}
    </div>
  );
}
